import { createRestSlice } from "./restSlice";

export type AgentJudgeRuling = {
  id: string;
  sessionId: string;
  evaluatorId: string;
  success?: boolean;
  ruling?: Record<string, unknown>;
  rulingSchema: Record<string, unknown>;
  successCriteria: Record<string, unknown>;
  error: boolean;
  createdAt: Date;
  updatedAt: Date;
  deletedAt: Date | null;
};

const agentJudgeRulingSlice = createRestSlice<AgentJudgeRuling>("agentJudgeRulings", "/v1/agents/:agentId/evaluators/:evaluatorId/rulings");

export const agentJudgeRulingReducer = agentJudgeRulingSlice.reducer;
export const agentJudgeRulingActions = agentJudgeRulingSlice.actions;
